export function setresume(resume) {
  return {
    type: 'SET_RESUME',
    resume,
  };
}
